module.exports = __webpack_public_path__ + "static/media/week-2-tip-1.dea2c150.mp3";